// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

export const constants = {
    header: {
        size: {
            sticky: 92,
        },
    },
    footer: {
        offsetTop: 52,
    },
    searchInput: {
        breakpoints: {
            lg: 1280,
        },
    },
};

export const EMPTY_VALUE = "- -";
export const DivWrapper = `div[class^="Wrapper"]`;
export const SignInZoneName = "SignInZone";
export const CartLinkZoneName = "CartLinkZone";

export const SLIDES_PER_VIEW_POINTS = {
    xs: 0,
    sm: 1,
    md: 2,
    lg: 3,
};
